var windowCallbacks = new Set();
var windowResizeHandler;
function createWindowResizeHandler() {
  windowResizeHandler = function windowResizeHandler() {
    var size = {
      width: window.innerWidth,
      height: window.innerHeight
    };
    var info = {
      target: window,
      size: size,
      contentSize: size
    };
    windowCallbacks.forEach(function (callback) {
      return callback(info);
    });
  };
  window.addEventListener("resize", windowResizeHandler);
}
function resizeWindow(callback) {
  windowCallbacks.add(callback);
  if (!windowResizeHandler) createWindowResizeHandler();
  return function () {
    windowCallbacks.delete(callback);
    if (!windowCallbacks.size && windowResizeHandler) {
      windowResizeHandler = undefined;
    }
  };
}
export { resizeWindow };